import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { IUIRuntime } from '@cian/mf-registry/browser';
import { IMicrofrontendManifest, IRegistry } from '@cian/mf-registry/shared';
import {
  IGetEarlyAccessPaywallMicrofrontendRequest,
  TGetEarlyAccessPaywallMicrofrontendResponse,
  fetchGetEarlyAccessPaywallMicrofrontend,
} from 'shared/common/repositories/early-access-paywall-frontend';

export type IFetchEarlyAccessPaywallParameters = IGetEarlyAccessPaywallMicrofrontendRequest;

export type TGetEarlyAccessPaywallMicrofrontendResult = {
  manifest: IMicrofrontendManifest;
} | null;

interface IContext {
  httpApi: IHttpApi;
  microfrontendsRegistry: IRegistry;
  logger: ILogger;
}

export async function getEarlyAccessPaywallMicrofrontend(
  context: IContext,
  parameters: IFetchEarlyAccessPaywallParameters = {},
): Promise<TGetEarlyAccessPaywallMicrofrontendResult> {
  const { httpApi, logger, microfrontendsRegistry } = context;

  try {
    const earlyAccessPaywallData: TGetEarlyAccessPaywallMicrofrontendResponse =
      await fetchGetEarlyAccessPaywallMicrofrontend({
        httpApi,
        parameters,
      });

    const image = microfrontendsRegistry.register(earlyAccessPaywallData.response.manifest);

    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
      const runtime = image.runtimeStrict<IUIRuntime>(earlyAccessPaywallData.response.manifest.runtimeName);
      await runtime.ensure();
    }

    return {
      manifest: earlyAccessPaywallData.response.manifest,
    };
  } catch (ex) {
    logger.error(ex, { domain: 'shared.services.getEarlyAccessPaywallMicrofrontend' });

    return null;
  }
}
